import type { IPartButton } from "@contentful-api/types/contentful";
import { mapLink } from "../link/mapLink";
import type { ButtonModel } from "./types";

export const mapButton = (button?: IPartButton): ButtonModel | undefined => {
    const link = mapLink(button?.fields?.link);
    if (!button || !link) return undefined;

    return {
        id: button.sys.id,
        label: button.fields.label,
        variant: button.fields.type,
        link,
    };
};

// Leaves out buttons that cannot link anywhere.
export const mapButtons = (buttons: readonly (IPartButton | undefined)[] = []): ButtonModel[] =>
    buttons.flatMap((button) => mapButton(button) ?? []);
